import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BreakPoint, Color, FontSize } from '../styles/constants';
import times from 'lodash/times';

const COL_SIZE = 5;

const borderColor = v => {
  switch (v) {
    case 0:
      return Color.border.red;
    case 1:
      return Color.border.orange;
    case 2:
      return Color.border.yellow;
    case 3:
      return Color.border.yellowGreen;
    case 4:
      return Color.border.lightGreen;
    default:
      return Color.border.red;
  }
};

const Box = styled.div`
  display: flex;
  width: 100%;
`;
const Col = styled.div`
  color: ${Color.text.gray};
  cursor: pointer;
  line-height: 1.5;
  text-align: center;
  width: 20%;
  font-size: 16px;
`;

const Border = styled.div`
  background-color: ${props => borderColor(props.index)};
  display: block;
  height: 4px;
  margin-top: 16px;
  width: 100%;
`;

const Circle = styled.div`
  background-color: ${props =>
    props.checked ? Color.border.lightGreen : Color.white};
  display: block;
  border: solid 2px
    ${props => (props.checked ? Color.border.lightGreen : Color.border.gray)};
  border-radius: 12px;
  height: 20px;
  width: 20px;
  margin: 0 auto 8px auto;
`;

const TextWrap = styled.div`
  position: relative;
  height: calc(${FontSize.tiny} + 8px);

  @media (min-width: ${BreakPoint.desktop}) {
    height: calc(${FontSize.desktop.tiny} + 8px);
  }
`;

const TextBox = styled.div`
  position: absolute;
  left: ${props => (props.index === 0 ? 0 : 'auto')};
  right: ${props => (props.index === 0 ? 'auto' : 0)};
`;

const Text = styled.div`
  color: ${Color.text.darkGray};
  font-size: ${FontSize.tiny};
  margin-top: 8px;
  text-align: ${props => (props.index === 0 ? 'left' : 'right')};
  white-space: nowrap;
  width: 100%;

  @media (min-width: ${BreakPoint.desktop}) {
    font-size: ${FontSize.desktop.tiny};
  }
`;

const ScoreRadio = props => (
  <Box>
    {times(COL_SIZE, i => (
      <Col key={i} onClick={() => props.onChange(props.optionValues[i])}>
        <Circle checked={props.optionValues[i] === props.value} />
        <div>{i + 1}</div>
        <Border index={i} />
        {(props.minScoreText || props.maxScoreText) && (
          <TextWrap>
            <TextBox index={i}>
              <Text index={i}>
                {i === 0
                  ? props.minScoreText
                  : i === COL_SIZE - 1
                    ? props.maxScoreText
                    : ''}
              </Text>
            </TextBox>
          </TextWrap>
        )}
      </Col>
    ))}
  </Box>
);

ScoreRadio.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  optionValues: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  onChange: PropTypes.func,
  minScoreText: PropTypes.string,
  maxScoreText: PropTypes.string,
};

ScoreRadio.defaultProps = {
  value: undefined,
  optionValues: [1, 2, 3, 4, 5],
  onChange: () => {},
  minScoreText: undefined,
  maxScoreText: undefined,
};

export default ScoreRadio;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/ScoreRadio.jsx